module.exports = __webpack_public_path__ + "img/feature-share.72d7ac29.png";